import {createAxiosClient} from "./axiosClientFactory";

let emailUrl = process.env.REACT_APP_MAIL_SERVER;
let xApiKey = process.env.REACT_APP_SEND_MAIL;

const emailClient = createAxiosClient(emailUrl, xApiKey, "",);

export default emailClient;


